import React, { useState } from 'react';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import AddOperationCard from './AddOperationCard';
import CustomDraggable from '../../../../Components/Common/CustomDraggable';
import OperationCollapse from './OperationCollapse';
import { setFeedInfoOperations, setIsChangesMade } from '../../../../slices/feeds/reducer';
import { feedOperations } from '../../../../common/feedTypes';
import checkPermission from '../../../../Components/Hooks/PermissionHook';


function SortingAndFilters() {
  const dispatch = useDispatch();

  const selectStates = createSelector(state => state, state => ({
    feedInfo: state.Feed.feedInfo,
    brandPath: state.MenuData.brandPath
  }));
  const {feedInfo, brandPath} = useSelector(selectStates);

  function addOperationFunc(data) {
    dispatch(setFeedInfoOperations([...feedInfo.operations, data]));
    dispatch(setIsChangesMade(true));
  }

  function setData(data) {
    dispatch(setFeedInfoOperations(data))
  }

  return (
    <React.Fragment>
      {feedInfo !== null && feedInfo.operations.length === 0 ?
        <React.Fragment>
          <Row>
            <Col>
              <p className='text-muted m-0'>
                Use operations in order to filter and alter the contents of your feeds to use only the data that is required.
              </p>
            </Col>
          </Row>
          <Row>
            <Col xl="3" lg="6" md="6" sm="12" className='my-3'>
              <AddOperationCard
                color='primary'
                textColor='primary'
                avatar="mdi mdi-sort-variant"
                header="Sorting"
                text="Need a different arrangement? Customize the order of your items, sorting any field to suit your preference."
                onClick={() => addOperationFunc(feedOperations[1])}
              />
            </Col>
            <Col xl="3" lg="6" md="6" sm="12" className='my-3'>
              <AddOperationCard
                color='warning'
                textColor='primary'
                avatar='ri-checkbox-circle-line'
                header='Priority'
                text='When some items need to stand out, set a custom priority. You can base it on any field within your content.'
                onClick={() => addOperationFunc(feedOperations[2])}
              />
            </Col>
            <Col xl="3" lg="6" md="6" sm="12" className='my-3'>
              <AddOperationCard
                color='success'
                textColor='primary'
                avatar='ri-filter-2-line'
                header='Filter'
                text='Adding a custom filter to your dynamic content is simple. Only want to display items in stock? You’re all set!'
                onClick={() => addOperationFunc(feedOperations[3])}
              />
            </Col>
            <Col xl="3" lg="6" md="6" sm="12" className='my-3'>
              <AddOperationCard
                color='info'
                textColor='info'
                header='Replace Text'
                text="Need to swap out specific text? Use a replace filter to choose the field and text you want to change, and what you'd like it changed to."
                onClick={() => addOperationFunc(feedOperations[4])}
              />
            </Col>
          </Row>
        </React.Fragment>
        : <CustomDraggable 
        data={(feedInfo?.operations || [])} 
        setData={(data) => setData(data)} 
        children={<OperationCollapse />} 
        permission={true}
        />}
    </React.Fragment >
  )
}

export default SortingAndFilters